/*----------------------------------------------------------------
  String helpers that manipulate / inspect SQL.
----------------------------------------------------------------*/

/** Extract every table name naïvely (good enough for autocomplete). */
export function extractTableNames(sql: string): string[] {
  const names =
    sql
      .toLowerCase()
      .match(/\b(from|join)\s+("[^"]+"|`[^`]+`|[a-z0-9_\.]+)/g)
      ?.map((m) => {
        const [, , raw] = m.split(/\s+/);
        return raw.replace(/["`]/g, "");
      }) ?? [];
  return [...new Set(names)];
}

/** Strip the *outermost* LIMIT from a query (keeps sub-query limits). */
export function stripLimit(sql: string): string {
  return sql.replace(/\s+limit\s+\d+\s*;?$/i, "").trim();
}

/** Append LIMIT n (after stripping any existing outer limit). */
export function withLimit(sql: string, n: number): string {
  return `${stripLimit(sql)} LIMIT ${n}`;
}

/* ──────────────────────────────────────────────────────────────── */
/* NEW HELPERS                                                     */
/* ──────────────────────────────────────────────────────────────── */

/** Return the user-supplied outer LIMIT if present – otherwise null. */
export function getLimit(sql: string): number | null {
  const m = sql.match(/\s+limit\s+(\d+)\s*;?$/i);
  return m ? Number(m[1]) : null;
}

/** Apply LIMIT n to the *outer* query, replacing any existing one. */
export function applyLimit(sql: string, n: number): string {
  return `${stripLimit(sql)} LIMIT ${n}`;
}
